module.exports = __webpack_public_path__ + "static/media/image_A5.5ff2f154.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog_images/image_A5.png
// module id = 436
// module chunks = 0